import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DemoChoiceDialogComponent } from './demo-choice-dialog.component';

@Injectable({ providedIn: 'root' })
export class DemoRequestService {
  constructor(private dialog: MatDialog) {}

  openDemoChoice(): void {
    this.dialog.open(DemoChoiceDialogComponent, {
      width: '90%',
      maxWidth: '460px',
      autoFocus: false,
    });
  }
}
